var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_679_32131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1672 0.54541C16.8294 0.54541 15.3646 1.20675 13.8194 2.51123C13.0903 3.12403 12.4482 3.79144 11.9799 4.3193C11.9799 4.3193 12.7291 5.10199 13.5519 5.94535C14 5.43569 14.6355 4.74402 15.3779 4.11908C16.7492 2.95415 17.6455 2.71752 18.1606 2.71752C20.087 2.71752 21.6522 4.18582 21.6522 5.99996C21.6522 7.79589 20.087 9.26419 18.1606 9.28239C18.0669 9.28239 17.9599 9.27026 17.8261 9.24599C18.388 9.48261 18.9967 9.6525 19.5652 9.6525C23.097 9.6525 23.7927 7.43792 23.8328 7.28017C23.9331 6.87365 23.9933 6.44894 23.9933 6.01209C23.9866 2.99662 21.3779 0.54541 18.1672 0.54541Z",
    fill: "url(#paint0_linear_679_32131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82609 11.4543C7.16388 11.4543 8.62876 10.7929 10.1739 9.48845C10.903 8.87565 11.5452 8.20824 12.0134 7.68038C12.0134 7.68038 11.2642 6.89769 10.4415 6.05433C9.99331 6.56399 9.35786 7.25566 8.61538 7.8806C7.24415 9.0334 6.34114 9.28216 5.83278 9.28216C3.90635 9.28216 2.34114 7.81386 2.34114 5.99972C2.34114 4.20379 3.90635 2.73549 5.83278 2.71729C5.92642 2.71729 6.03344 2.72942 6.16722 2.75369C5.60535 2.51707 4.99665 2.34718 4.42809 2.34718C0.896321 2.34111 0.200669 4.5557 0.160535 4.71951C0.0602007 5.12603 0 5.55074 0 5.98759C0 9.00306 2.6087 11.4543 5.82609 11.4543Z",
    fill: "url(#paint1_linear_679_32131)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51505 4.16762C8.12709 3.82784 6.2408 2.43842 4.43478 2.38988C1.2107 2.31708 0.26756 4.44065 0.180603 4.71368C0.802676 2.33528 3.10368 0.557545 5.83278 0.54541C8.0602 0.54541 10.3144 2.52943 11.9799 4.3193L11.9866 4.31323C11.9866 4.31323 12.7358 5.09592 13.5585 5.93928C13.5585 5.93928 14.495 6.94039 15.4849 7.82016C15.8729 8.15993 17.7525 9.53115 19.5585 9.57969C22.8696 9.66463 23.7859 7.41971 23.8328 7.24983C23.2241 9.64643 20.9164 11.4302 18.1739 11.4424C15.9465 11.4424 13.6923 9.45834 12.0201 7.66848C12.0201 7.67454 12.0134 7.67454 12.0134 7.68061C12.0134 7.68061 11.2642 6.89792 10.4415 6.05456C10.4482 6.05456 9.51171 5.04738 8.51505 4.16762Z",
    fill: "#29ABE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_679_32131",
    x1: 15.0358,
    y1: 1.40979,
    x2: 22.4743,
    y2: 9.67789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6841,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_679_32131",
    x1: 8.95961,
    y1: 10.5911,
    x2: 1.5211,
    y2: 2.32303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8929,
    stopColor: "#522785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_32131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 10.9091,
    fill: "white",
    transform: "translate(0 0.54541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.28d3cddb1bb101dda45322da088a4646.svg";
export { ForwardRef as ReactComponent };